import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  RdsCardModule,
  RdsIconsModule,
  RdsButtonModule,
  RdsLinkModule,
  RdsBadgeModule,
} from '@rds/angular-components';
import { DynamicModule } from 'ng-dynamic-component';
import { Days } from '../../../enums/days.enum';
import {PANORAMA_OFFERING_TEXTS} from '../../../constants/panorama.constants';

@Component({
  selector: 'inexp-offering-support-hours',
  imports: [
    RdsCardModule,
    RdsIconsModule,
    RdsButtonModule,
    RdsBadgeModule,
    DynamicModule,
    RdsLinkModule,
    RouterModule,
    CommonModule,
  ],
  templateUrl: './offering-support-hours.component.html',
  styleUrl: './offering-support-hours.component.scss',
})
export class OfferingSupportHoursComponent {
  _uid = input<string>();
  component = input<string>();
  section = input<string>();
  supportHours = input<any[]>();
  readonly OFFERING_TEXT = PANORAMA_OFFERING_TEXTS;

  private readonly _totalDays = Object.values(Days).length;

  formatDays(days: string[]): string {
    if (days?.length === this._totalDays) {
      return `${Days.MONDAY} - ${Days.SUNDAY}`;
    }
    return days?.join(', ') ?? '';
  }
}
